"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHttpStatusSuccess = exports.checkRequiredParams = exports.checkConfig = void 0;
function isBoolean(value) {
    return typeof value === 'boolean';
}
function checkConfig(service, envConfig, ...args) {
    if (!envConfig || typeof envConfig !== 'object') {
        throw new Error(`Service configuration failed ${service} requires the environmental config to be passed`);
    }
    for (const arg of args) {
        if (!envConfig[arg] && !isBoolean(envConfig[arg])) {
            console.error(`%s Failed to configure service, one or more env configs is missing.
                Check your environmental config for %s`, service, arg);
            throw new Error(`Failed to configure ${service}`);
        }
    }
}
exports.checkConfig = checkConfig;
function checkRequiredParams(method, params, ...args) {
    if (!params || (typeof params !== 'object' && params !== null)) {
        throw new Error(`${method}() -> params must be an object`);
    }
    if (args && args.length > 0) {
        for (const arg of args) {
            if (!params[arg]) {
                console.error(`Failed to to call method %s, one or more params is missing.
                    missing parameter %s`, method, arg);
                throw new Error(`Failed to call ${method}`);
            }
        }
    }
}
exports.checkRequiredParams = checkRequiredParams;
function isHttpStatusSuccess(status) {
    return !!(status && status >= 200 && status < 300);
}
exports.isHttpStatusSuccess = isHttpStatusSuccess;
//# sourceMappingURL=ServiceUtils.js.map